import React from 'react'
import PropTypes from 'prop-types'
import UsersList from './UsersList'
import AlertContainer from 'react-alert'
import { listUsers } from '../../api/users'
import ListController from '../../components/ListController'

class UsersListContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)

    const sortBys = [
      'firstName',
      'lastName',
      'email'
    ]

    this.state = {
      sortBys,
      fetchList: listUsers,
      initialSortBy: 'firstName',
      initialSortDirection: 'ASC'
    }
  }

  newUser = () => {
    this.props.history.push(`/users/edit/new`)
  }

  render () {
    const methods = {
      newUser: this.newUser
    }
    return <div>
      <ListController
        {...methods}
        {...this.props}
        {...this.state}
        displayComponent={UsersList} />
      <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
    </div>
  }
}

UsersListContainer.propTypes = {
  history: PropTypes.object
}

export default UsersListContainer



// WEBPACK FOOTER //
// ./src/pages/UsersList/UsersListContainer.js